import AxiosFactory from "./axiosFactory";
import sharedConfig from "./config";

export default new AxiosFactory({
    baseURL: sharedConfig.centralBackendURL,
    withCredentials: true,
    paramsSerializer: {
        indexes: null, // Tells axios to set each element in the array as a separate parameter (e.g., ?file_id=12938471&file_id=9048545&file_id=349538)
    },
}).create("api");
